/**
 * The condition is similar to skip_recaptcha method from
 * app/controllers/concerns/recaptcha_verification.rb
 */
export const isRecaptchaDisabled = () => {
  const env = process.env.RAILS_ENV || process.env.NODE_ENV || 'development'
  const isTest = env === 'test'
  const isDevelopment = env === 'development'
  const isShipyard = !!process.env.SHIPYARD_DOMAIN

  return isTest || isDevelopment || isShipyard
}

/**
 * Returns empty values if reCAPTCHA is disabled,
 * but still throw an error if grecaptcha is enabled but not loaded.
 */
export const getRecaptchaLoginActionToken = async (): Promise<{
  recaptchaToken?: string
  recaptchaAction?: string
}> => {
  return new Promise((resolve, reject) => {
    if (isRecaptchaDisabled()) {
      resolve({})
      return
    }

    if (!grecaptcha?.enterprise) {
      reject(new Error('grecaptcha not loaded, check initialization logic'))
      return
    }

    const timeout = setTimeout(() => {
      reject(new Error('grecaptcha timeout'))
    }, 15000)

    grecaptcha.enterprise.ready(async () => {
      try {
        const recaptchaAction = 'LOGIN'
        const recaptchaToken = await grecaptcha.enterprise.execute(
          process.env.GOOGLE_RECAPTCHA_KEY || '',
          { action: recaptchaAction },
        )
        resolve({ recaptchaToken, recaptchaAction })
      } catch (error) {
        reject(error)
      } finally {
        clearTimeout(timeout)
      }
    })
  })
}
